import React from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';

import {
  academyTopicSelector,
  CLASS_CREATION_STATUSES,
} from 'features/classCreation';
import styles from './ClassCreationTrackerRow.module.scss';
import TableCell from 'components/TableCell';
import TableRow from 'components/TableRow';
import toDDMMMYYYYHHMM from 'utils/toDDMMMYYYYHHMM';

const STATUS_LABEL_MAP = {
  [CLASS_CREATION_STATUSES.pending]: 'Creating...',
  [CLASS_CREATION_STATUSES.failure]: 'Failed!',
  [CLASS_CREATION_STATUSES.success]: 'Created',
};

const STATUS_CLASSNAME_MAP = {
  [CLASS_CREATION_STATUSES.pending]: 'warning',
  [CLASS_CREATION_STATUSES.failure]: 'danger',
  [CLASS_CREATION_STATUSES.success]: 'success',
};

function ClassCreationTrackerRow({ cls, status }) {
  const {
    primaryInstructor,
    secondaryInstructor,
    otherInstructors,
    dateOfTopic,
  } = useSelector((state) => academyTopicSelector(state, cls.academy_topic.id));

  return (
    <TableRow className={styles.root}>
      <TableCell>{cls.academy_topic.title}</TableCell>
      <TableCell>{primaryInstructor?.label || '-'}</TableCell>
      <TableCell>{secondaryInstructor?.label || '-'}</TableCell>
      <TableCell>
        {otherInstructors.map((o) => o.label).join(', ') || '-'}
      </TableCell>
      <TableCell>{toDDMMMYYYYHHMM(dateOfTopic)}</TableCell>
      <TableCell>
        <span className={classNames('bold', STATUS_CLASSNAME_MAP[status])}>
          {STATUS_LABEL_MAP[status]}
        </span>
      </TableCell>
    </TableRow>
  );
}

export default ClassCreationTrackerRow;
